import * as React from 'react'

interface OrderLoadingMessageProps {
  innerProps: React.HTMLAttributes<HTMLElement>
  children: React.ReactNode
}

function OrderLoadingMessage({ innerProps, children }: OrderLoadingMessageProps) {
  return (
    <tr {...innerProps}>
      <td colSpan={6}>{children}</td>
    </tr>
  )
}

export default OrderLoadingMessage
